// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiline-diff-ellipsis--truncated {
  word-break: break-word;
  white-space: nowrap;
}
.multiline-diff-ellipsis__text {
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/multiline-diff-ellipsis/MultiLineDiffEllipsis.less"],"names":[],"mappings":"AACE;EACE,sBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,qBAAA;AADJ","sourcesContent":[".multiline-diff-ellipsis {\n  &--truncated {\n    word-break: break-word;\n    white-space: nowrap;\n  }\n\n  &__text {\n    white-space: pre-wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
